import React from 'react';

import { useAppDispatch, useAppSelector } from 'utils/hooks';

import Button from 'components/shared/Button';
import Spinner from 'components/shared/Spinner';

import cartProductCreator from 'domains/cart_product_creator';
import multiphotos from 'domains/multiphotos';

import { selectMultiPhotoCartPhotos } from 'selectors/cart_photos';
import { selectPriceTotal } from 'selectors/prices';

import type { SharedAddToCartProps } from './AddToCartWrapper';

function MultiPhotoAddToCart(props: SharedAddToCartProps) {
  const { quantity, disable } = props;

  const dispatch = useAppDispatch();
  const multiphotoIds = useAppSelector(multiphotos.selectors.selectIds);
  const cartPhotos = useAppSelector(selectMultiPhotoCartPhotos);
  const isProcessing = useAppSelector(cartProductCreator.selectors.isProcessing);
  const total = useAppSelector(selectPriceTotal);

  function handleAddToCartClick() {
    dispatch(cartProductCreator.actions.addToCart.pending('multiphoto'));
  }

  const cropsNotReady = cartPhotos.length !== multiphotoIds.length;

  return (
    <Button
      type="cornered"
      className="cart_button"
      disabled={disable || cropsNotReady}
      onClick={handleAddToCartClick}
    >
      {!isProcessing && (
        <span>
          <span>Add {quantity * multiphotoIds.length} items to cart</span>
          <span className="price">| ${(total * multiphotoIds.length * quantity).toFixed(2)}</span>
        </span>
      )}

      {isProcessing && <Spinner />}
    </Button>
  );
}

export default MultiPhotoAddToCart;
